import usePrivateAxios from '@/common/api/usePrivateAxios'
import { Mapper } from '@/common/services/mapper'
import { useQuery } from '@tanstack/react-query'

type UseMaintenanceForwardingsPossibleStatusesProps<T> = {
  mapper?: (data: any) => T
}

export const useMaintenanceForwardingsPossibleStatuses = <T = Record<string, string>>({
  mapper = Mapper.default<T>(),
}: UseMaintenanceForwardingsPossibleStatusesProps<T> = {}) => {
  const privateAxios = usePrivateAxios()

  return useQuery({
    queryKey: ['maintenanceForwardingsPossibleStatuses'],
    queryFn: () => privateAxios.get('/maintenance/forwardings/possible_statuses'),
    select: (data: { data: { data: Record<string, string> } }) => mapper(data?.data?.data),
  })
}
